import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiService } from '../../services/apiService';

interface AppState {
  appInfo: any;
  healthStatus: any;
  syncStatus: any;
  loading: boolean;
  error: string | null;
}

const initialState: AppState = {
  appInfo: null,
  healthStatus: null,
  syncStatus: null,
  loading: false,
  error: null,
};

export const fetchAppInfo = createAsyncThunk(
  'app/fetchAppInfo',
  async () => {
    const response = await apiService.getAppInfo();
    return response.data;
  }
);

export const fetchHealthStatus = createAsyncThunk(
  'app/fetchHealthStatus',
  async () => {
    const response = await apiService.getHealthStatus();
    return response.data;
  }
);

export const fetchSyncStatus = createAsyncThunk(
  'app/fetchSyncStatus',
  async () => {
    const response = await apiService.getAdminSyncStatus();
    return response.data;
  }
);

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAppInfo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAppInfo.fulfilled, (state, action) => {
        state.loading = false;
        state.appInfo = action.payload;
      })
      .addCase(fetchAppInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch app info';
      })
      .addCase(fetchHealthStatus.fulfilled, (state, action) => {
        state.healthStatus = action.payload;
      })
      .addCase(fetchSyncStatus.fulfilled, (state, action) => {
        state.syncStatus = action.payload;
      });
  },
});

export const { clearError } = appSlice.actions;
export default appSlice.reducer;
